<template>
  <BaseDialog :is-open="isOpen" @close="emit('close')">
    <div class="py-4">
      <h2 class="text-center text-lg font-semibold"
        >Confirm Terminal Activation</h2
      >
      <h3
        class="mb-2 text-center text-xs text-background-fg/50"
        >SN: {{ props.terminalId }}
      </h3>
      <template v-if="isLoading">
        <div>
          <QueryLoading spinner-class="size-8" />
          <p
            class="mb-3 text-center text-sm font-semibold text-background-fg/70"
          >
            Confirming...
          </p>
        </div>
      </template>
      <template v-else>
        <p
          class="mb-3 text-center text-sm font-semibold text-background-fg/70"
        >
          Are you sure you want to approve activation for
          this terminal?
        </p>
        <div class="text-center">
          <ButtonPrimary
            class="mt-2 self-end"
            @click="emit('close')"
            >Cancel</ButtonPrimary
          >
          <ButtonPrimary
            class="ml-1 mt-2 self-end"
            @click="confirm"
            >Approve</ButtonPrimary
          >
        </div>
        <template v-if="!!errorText">
          <p class="mt-3 text-center text-xs text-error">{{
            errorText
          }}</p>
        </template>
      </template>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
const props = defineProps<{
  isOpen: boolean
  terminalId: string
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const isLoading = ref(false)
const errorText = ref("")

watch(props, () => {
  errorText.value = ""
  isLoading.value = false
})

const confirm = async () => {
  try {
    errorText.value = ""
    isLoading.value = true
    await confirmTerminal({
      serialNumber: props.terminalId,
    })
    emit("close")
  } catch (err) {
    if (err instanceof ApiError) {
      switch (err.status) {
        case 404:
          errorText.value = `Terminal with serial number: ${props.terminalId} could not be found`
          break
        case 422:
          errorText.value =
            "This terminal is not currently awaiting confirmation."
          break
        default:
          errorText.value =
            "There was an error when trying to confirm. Please try again."
      }
    } else {
      errorText.value =
        "There was an error when trying to confirm. Please try again."
    }
  } finally {
    isLoading.value = false
  }
}
</script>
